import { syncToLocal } from '../mixins'

export default {
  namespaced: true,

  actions: {
    afterCreate (context, record) {
      if (!context.rootState.allowChanges) {
        context.dispatch('projects/update', {
          where: record.project_id,
          data: {
            savedOnServer: false
          }
        })
      }

      syncToLocal(context)
    },

    afterUpdate (context, record) {
      if (!context.rootState.allowChanges) {
        context.dispatch('projects/update', {
          where: record.project_id,
          data: {
            savedOnServer: false
          }
        })
      }

      syncToLocal(context)
    },

    afterDelete (context, record) {
      if (!context.rootState.allowChanges) {
        context.dispatch('projects/update', {
          where: record.project_id,
          data: {
            savedOnServer: false
          }
        })
      }

      syncToLocal(context)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/contacts.js